import { Dispatch } from "redux";

import { ActionType } from "../action-types";
import {
  DeleteCellAction,
  InsertCellAfterAction,
  MoveCellAction,
  UpdateCellAction,
  Direction,
  Action,
} from "../actions";
import { Cell, CellType } from "../cell";
import bundle from "../../bundler";
import { RootState } from "../reducers";
import { placeholderCells, SAVED_CELLS_LOCAL_STORAGE_KEY } from "../constants";

export const updateCell = (id: string, content: string): UpdateCellAction => {
  return {
    type: ActionType.UPDATE_CELL,
    payload: {
      id,
      content,
    },
  };
};

export const deleteCell = (id: string): DeleteCellAction => {
  return {
    type: ActionType.DELETE_CELL,
    payload: id,
  };
};

export const moveCell = (id: string, direction: Direction): MoveCellAction => {
  return {
    type: ActionType.MOVE_CELL,
    payload: {
      id,
      direction,
    },
  };
};

export const insertCellAfter = (
  id: string | null,
  type: CellType
): InsertCellAfterAction => {
  return {
    type: ActionType.INSERT_CELL_AFTER,
    payload: {
      id,
      type,
    },
  };
};

export const createBundle = (cellId: string, input: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.BUNDLE_START,
      payload: { cellId },
    });

    const result = await bundle(input);

    dispatch({
      type: ActionType.BUNDLE_COMPLETE,
      payload: {
        cellId,
        bundle: result,
      },
    });
  };
};

export const loadCells = () => {
  return (dispatch: Dispatch<Action>) => {
    let cells: Cell[] = [];
    const savedCells = localStorage.getItem(SAVED_CELLS_LOCAL_STORAGE_KEY);
    if (savedCells && savedCells !== "[]") {
      cells = JSON.parse(savedCells);
    } else {
      cells = placeholderCells;
    }

    dispatch({
      type: ActionType.LOAD_CELLS,
      payload: cells,
    });
  };
};

export const saveCells = () => {
  return (_: Dispatch<Action>, getState: () => RootState) => {
    const {
      cells: { data, order },
    } = getState();
    const cells = order.map((id) => data[id]);
    localStorage.setItem(SAVED_CELLS_LOCAL_STORAGE_KEY, JSON.stringify(cells));
  };
};
